import React, { Component } from "react";
import Notificacao from "../Notificacao";
import moment from "moment";
import { updateCirurgia } from "../../Libs/cirurgia";
import Input from "../../components/Input";
import Popup from "reactjs-popup";
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../../helpers/firebase-config";


export default class Cirurgia extends Component {
  state = {
    hora: "",
    idPaciente: "",
    idCirurgia: "",
    comentario: "",
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false,
    cidade: "",
    paciente: null,
    dataCirurgia: null
  };

  componentDidMount() {
    this.setState({
      idPaciente: this.props.idPaciente,
      idCirurgia: this.props.item.id
    });
  }

  _reagendar = e => {
    e.preventDefault();
    const { idPaciente, idCirurgia } = this.state;
    let data = "";

    data = { HoraCirurgia: this.state.hora, DataCirurgia: this.state.dataCirurgia };

    updateCirurgia(idPaciente, idCirurgia, data)
      .then(() => {
        Libfirebase.collection("paciente")
        .doc(idPaciente).update({
          status : 'Agendado'
        });
        alert(`Horário da cirurgia alterado com sucesso.`);
      })
      .catch(error =>
        this.setState({
          notifition: true,
          msg: error,
          nameclass: "alert-danger"
        })
      );
  };

  _changeStatus = (e, tipoStatus) => {
    const { idPaciente, idCirurgia } = this.state;
    e.preventDefault();
    let data = "";
    if (tipoStatus === "realizada") {
      data = { realizada: true, cancelada: false };
    } else if (tipoStatus === "cancelada") {
      data = { cancelada: true, realizada: false };
    }

    updateCirurgia(idPaciente, idCirurgia, data)
      .then(() => {
        Libfirebase.collection("paciente")
        .doc(idPaciente).update({
          status : 'Finalizado'
        }).then(r => window.location.reload(false));

        alert(
          `Status da cirurgia alterado para ${
            tipoStatus === "realizada" ? "realizada" : "cancelada"
          } com sucesso.`
        );
      })
      .catch(error =>
        this.setState({
          notifition: true,
          msg: error,
          nameclass: "alert-danger"
        })
      );
  };

  render() {


    return (
      <div>
        <div
          id="react-no-print"
          // className="container"
          // style={{
          //   overflowY: "scroll",
          //   overflowX: "hidden",
          //   maxHeight: "80vh"
          // }}
        >
          <div>
            <h4>Cirurgia</h4>
            <hr/>
            <br/>
            <p><strong>Hospital: </strong>{this.props.item.cirurgia.Hospital}</p>
            <p><strong>Data da Cirurgia: </strong>{moment(this.props.item.cirurgia.DataCirurgia).format("DD/MM/YYYY")}</p>
            <p><strong>Horário da Cirurgia: </strong>{this.props.item.cirurgia.HoraCirurgia}</p>
            <p><strong>Solicitar Material: </strong>{this.props.item.cirurgia.SolicitarMaterial}</p>
            {this.state.visible ? (
              <Input
                label="Hora*:"
                placeholder="Hora"
                type="time"
                id="dataCirurgia"
                value={this.state.hora}
                onChange={text => this.setState({ hora: text })}
                icone="fa fa-clock"
              />
            ) : null}
            <p>
              <br />
              {moment(
                this.props.item.cirurgia.DataCriacao,
                "DD-MM-YYYY"
              ).format("DD/MM/YYYY")}
            </p>
            <div className="gb-row" style={{width:'100%', justifyContent:'space-between'}}>
              <div className="gb-row">
                {/* <div
                  style={{
                    display: this.props.item.cirurgia.realizada ? 'none' : null,
                    marginBottom: 10,
                    flex: 1
                  }}
                > */}
                  {(!this.props.item.cirurgia.realizada)?<a
                    onClick={event => this._changeStatus(event, "cancelada")}
                    href="#"
                    className="btn gb-button-border mr-2"
                    style={{height:59}}
                  >
                    Cirurgia Cancelada
                  </a>:null}
                {/* </div> */}
                
                {(!this.props.item.cirurgia.realizada )?<div>
                  {/* style={{
                    display: this.props.item.cirurgia.realizada ? 'none' : null,
                    marginBottom: 10,
                    alignSelf: "right",
                    alignContent: "right",
                    flex: 1
                  }}
                > */}
                  <Popup
                    style={{ width: "1000px" }}
                    trigger={
                      <a
                        // onClick={event => this._reagendar(event)}
                        href="#"
                        className="btn gb-button-border"
                        style={{height:59}}
                      >
                        {this.props.item.cirurgia.DataCirurgia ? `Reagendar` : 'Agendar'}
                      </a>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                      }}
                    >
                      {" "}
                      <center><p><b>Data*:</b></p></center>
                      <input
                        label="Data*:"
                        className="form-control" 
                        placeholder="Data da Cirugia"
                        type="date"
                        id="dataCirurgia"
                        // value={this.state.dataCirurgia}
                        onChange={text =>
                          this.setState({ dataCirurgia: text.target.value })
                        }
                        // icone="fa fa-calendar"
                      />

                      <center><p><b>Hora*:</b></p></center>
                      <input
                        className="form-control" 
                        label="Hora*:"
                        placeholder="Hora"
                        type="time"
                        id="dataCirurgiaEdit"
                        // value={this.state.hora}
                        onChange={text => this.setState({ hora: text.target.value })}
                        // icone="fa fa-clock"
                      />
                      
                      <div
                        style={{
                          marginTop: 10,
                          marginBottom: 10,
                          alignSelf: "center",
                          alignContent: "center",
                          flex: 1
                        }}
                      >
                        <a
                          onClick={event => this._reagendar(event)}
                          href="#"
                          className="btn btn-outline-info btn-rounded"
                        >
                          Concluir
                        </a>
                      </div>
                    </div>
                  </Popup>
                </div>:null}
              </div>
              {/* <div
                style={{
                  display: this.props.item.cirurgia.realizada ? 'none' : null,
                  marginBottom: 10,
                  float: 'right',
                  flex: 1
                }}
              > */}
                {(!this.props.item.cirurgia.realizada)?<a
                  onClick={event => this._changeStatus(event, "realizada")}
                  href="#"
                  className="btn gb-button to-form right"
                >
                  Cirurgia Realizada
                </a>:null}
              {/* </div> */}

            </div>
          </div>
          <br />

          {this.state.notifition ? (
            <Notificacao
              msg={this.state.msg}
              nameclass={this.state.nameclass}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
